import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/components/_checkbox.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem('checkbox', styles);
var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      extraClasses = _ref.extraClasses,
      label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      valid = _ref.valid,
      info = _ref.info,
      infoError = _ref.infoError,
      small = _ref.small,
      rest = _objectWithoutProperties(_ref, ["id", "extraClasses", "label", "value", "disabled", "valid", "info", "infoError", "small"]);

  return React.createElement("div", {
    className: bem.b({
      disabled: disabled,
      error: valid === false,
      sm: small
    }, extraClasses)
  }, React.createElement("input", _extends({
    id: id,
    className: "".concat(bem.e('input')),
    type: "checkbox",
    disabled: disabled,
    value: value
  }, rest)), React.createElement("label", {
    htmlFor: id,
    className: "".concat(bem.e('label'))
  }, label), valid === false && infoError && React.createElement("span", {
    className: bem.e('info')
  }, infoError), info && React.createElement("span", {
    className: bem.e('info')
  }, info));
};
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  extraClasses: '',
  disabled: null,
  valid: null,
  info: null,
  infoError: null,
  small: false
};
Checkbox.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Id for this checkbox, also used "for" label */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Provides label text, required if aria-label is not passed */

  /* eslint-disable react/require-default-props */
  // we want label to be always checked against
  label: function label(_ref2) {
    var ariaLabel = _ref2['aria-label'],
        _label = _ref2.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !_label ? new Error('Either label or aria label are required') : null;
  },

  /** Value for this checkbox */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Disables the input if set */
  disabled: PropTypes.bool,

  /** Triggers visual validation output */
  valid: PropTypes.bool,

  /** Provides extra information for this input field */
  info: PropTypes.string,

  /** Provides extra information for an error, gets displayed only when `valid` is set to false */
  infoError: PropTypes.string,

  /** Shows smaller checkbox */
  small: PropTypes.bool
};
var checkbox = Injecss(Checkbox, styles);

export default checkbox;
export { Checkbox };
